import { defineComponent as _defineComponent } from 'vue'
import { computed } from "vue";

// Environment variables

export default /*#__PURE__*/_defineComponent({
  __name: 'DeploymentInfo',
  setup(__props) {

const version = process.env.VUE_APP_RELEASE_VERSION || "N/A";
const commitHash = process.env.VUE_APP_COMMIT_ID || "N/A";
const githubLink = process.env.VUE_APP_GITHUB_LINK || "#";
const buildDate = process.env.VUE_APP_BUILD_DATE || "N/A";

// Computed properties
const isProduction = computed(() => {
  return version !== "N/A" && version !== "";
});

const shortCommitHash = computed(() => {
  return commitHash.slice(0, 7);
});

const commitUrl = computed(() => {
  return githubLink !== "#" ? githubLink : "#";
});

const formattedBuildDate = computed(() => {
  if (buildDate === "N/A") return "Nicht verfügbar auf localhost";
  try {
    const date = new Date(buildDate);
    return date.toLocaleDateString("de-DE", {
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  } catch {
    return buildDate;
  }
});

return { __sfc: true,version, commitHash, githubLink, buildDate, isProduction, shortCommitHash, commitUrl, formattedBuildDate }
}

})